import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionDataSection,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { PriceActivityModel } from './price-activity.model';

export class WeekPriceVolumeConfiguration extends ReportSectionConfigurationBase {
  readonly reportViewModelSections = [ReportViewModelSection.BnyManagementReport_WeekPriceVolume];
  typeName = 'WeekPriceVolumeConfiguration';
  nodataLocalizationKeyName = 'bnyWeekPriceActivity';
  readonly reportSection = ReportSection.WeekPriceVolume;
  readonly applicableReportTypes = [ReportType.BnyManagementReport];
  maxSize = 4;
  defaultSize = 2;
  minSize = 2;
  name = 'weekPriceVolume';
  displayName = '52 Week Price Change & Trading Volume';
  readonly availableDataSections: ReportSectionDataSection[] = [];
}

export interface WeekPriceVolumeDetailsData {
  [ReportViewModelSection.BnyManagementReport_WeekPriceVolume]: PriceActivityModel;
}
